module.exports = __webpack_public_path__ + "images/Time-out.png";